// FiltersModal.js
import ReactDOM from "react-dom";
import CloseIcon from "@mui/icons-material/Close";

const FiltersModal = ({
  show,
  onClose,
  handleTabs,
  tab,
  options,
  mydata,
  originaldata,
  uniqueProvider,
  uniqueVisitType,
  selectedProviders,
  selectedVisits,
  handleProviderClick,
  handleVisitClick,
  handleRecordType,
  handleClear,
  filterOnCloseHandler,
  setSelectedVisits
}) => {
  if (!show) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center z-[9999] bg-black bg-opacity-30"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          filterOnCloseHandler();
          setSelectedVisits([]);
        }
      }}
    >
      <div
        className="w-[500px] bg-white p-4 rounded-lg shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-11">
          <div className="font-bold text-black text-base tracking-[0.16px]">Filters</div>
          <CloseIcon
            style={{ color: "#B4B4B4", cursor: "pointer" }}
            onClick={() => {
              filterOnCloseHandler();
              setSelectedVisits([]);
            }}
          />
        </div>

        {/* Patient Status */}
        <div className="w-full flex flex-col items-start mb-4">
          <div className="font-semibold text-black text-[14px] mb-2">Patient Status</div>
          <div className="flex flex-col gap-4">
            {options.map((option) => (
              <label key={option.value} className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="tab"
                  value={option.value}
                  checked={tab === option.value}
                  onChange={() => handleTabs(option.value)}
                  className="cursor-pointer accent-black"
                />
                <span>{option.label}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="h-[1px] bg-[#E4E4E7] mb-2 w-full"></div>

        {/* Provider & Visit Type */}
        {mydata.usertype === "PRO" && (
          <>
            {/* Provider Section */}
            <div className="w-full flex flex-col items-start mb-4">
              <div className="font-semibold text-black text-[14px]">Provider</div>
              {originaldata.length ? (
                <div className="flex flex-wrap gap-2 mt-4">
                  {uniqueProvider.map((provider, index) => (
                    <button
                      key={index}
                      onClick={() => handleProviderClick(provider)}
                      className={`min-w-24 p-2 h-8 shadow-lg rounded-[14px] text-[10px] font-semibold flex items-center justify-center transition-colors duration-300 ${
                        selectedProviders.includes(provider)
                          ? "bg-[#A2C6FD] text-white"
                          : "bg-white text-black border border-gray-300"
                      }`}
                    >
                      {provider}
                    </button>
                  ))}
                </div>
              ) : (
                <>No Providers Available</>
              )}
            </div>

            <div className="h-[1px] bg-[#E4E4E7] mb-2 w-full"></div>

            {/* Visit Type Section */}
            <div className="w-full flex flex-col items-start">
              <div className="font-semibold text-black text-[14px]">Visit Type</div>
              {originaldata.length ? (
                <div className="flex flex-wrap gap-2 mt-4">
                  {uniqueVisitType.map((visit, index) => (
                    <button
                      key={index}
                      onClick={() => handleVisitClick(visit)}
                      className={`p-2 h-8 rounded-[14px] shadow-lg text-[10px] font-semibold flex items-center justify-center transition-colors duration-300 ${
                        selectedVisits.includes(visit)
                          ? "bg-[#A2C6FD] text-white"
                          : "bg-white text-black border border-gray-300"
                      }`}
                    >
                      {visit}
                    </button>
                  ))}
                </div>
              ) : (
                <>No Visits Available</>
              )}
            </div>

            <div className="h-[1px] bg-[#E4E4E7] mt-2 w-full"></div>
          </>
        )}

        {/* Action Buttons */}
        <div className="flex mt-5 items-center justify-evenly w-full">
          {originaldata.length ? (
            <>
              <button
                className="p-2 h-8 w-[30%] rounded-[14px] shadow-lg text-[10px] font-semibold bg-white text-black border border-gray-300"
                onClick={() => {
                  if (mydata.usertype !== "PRO") {
                    onClose();
                    return;
                  }
                  handleRecordType(selectedProviders, selectedVisits, true);
                  filterOnCloseHandler();
                }}
              >
                Apply
              </button>
              <button
                className="p-2 h-8 w-[30%] rounded-[14px] shadow-lg text-[10px] font-semibold bg-white text-black border border-gray-300"
                onClick={() => {
                  handleTabs("ALL");
                  handleClear();
                  filterOnCloseHandler();
                }}
              >
                Clear
              </button>
            </>
          ) : null}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default FiltersModal;
